type DownloadProps = {
  className: string;
  color?: string;
};

export default function Download(props: DownloadProps) {
  const color = props.color ?? "#003399";
  const className = props.className ?? "";
  return (
    <div className={className}>
      <svg
        style={{ width: "inherit", height: "inherit" }}
        viewBox="0 0 701 706"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M676.331 705.83H25.6006C12.0106 705.83 0.950195 694.11 0.950195 679.71V488.37C0.952845 483.73 2.79779 479.28 6.0791 475.999C9.36041 472.717 13.8097 470.873 18.4502 470.87C23.0915 470.87 27.5433 472.714 30.8252 475.996C34.1071 479.277 35.9502 483.729 35.9502 488.37V670.87H665.95V488.37C665.95 483.729 667.794 479.277 671.076 475.996C674.358 472.714 678.809 470.87 683.45 470.87C688.091 470.873 692.54 472.717 695.822 475.999C699.103 479.28 700.948 483.73 700.95 488.37V679.75C700.97 694.11 689.921 705.83 676.331 705.83Z"
          fill={color}
        />
        <path
          d="M350.971 605.82C348.672 605.822 346.395 605.37 344.271 604.491C342.148 603.612 340.218 602.323 338.593 600.697C336.967 599.072 335.679 597.142 334.8 595.019C333.921 592.895 333.469 590.619 333.471 588.32V18.2402C333.469 15.9417 333.921 13.6653 334.8 11.5415C335.679 9.41772 336.967 7.48808 338.593 5.8628C340.218 4.23751 342.148 2.94833 344.271 2.06934C346.395 1.19035 348.672 0.738923 350.971 0.740237C355.612 0.740237 360.063 2.58384 363.345 5.86573C366.627 9.14761 368.471 13.5989 368.471 18.2402V588.37C368.457 593.003 366.608 597.441 363.327 600.712C360.047 603.983 355.603 605.82 350.971 605.82Z"
          fill={color}
        />
        <path
          d="M350.971 605.82C348.64 605.826 346.331 605.363 344.182 604.459C342.033 603.555 340.087 602.23 338.46 600.56L174.12 432.66C170.875 429.343 169.079 424.872 169.128 420.232C169.177 415.591 171.066 411.159 174.381 407.91C176.024 406.303 177.967 405.034 180.1 404.178C182.233 403.321 184.513 402.893 186.812 402.919C189.11 402.944 191.38 403.421 193.494 404.324C195.608 405.227 197.524 406.537 199.131 408.18L363.471 576.08C366.716 579.398 368.512 583.868 368.463 588.509C368.414 593.15 366.524 597.581 363.21 600.83C359.941 604.032 355.547 605.824 350.971 605.82Z"
          fill={color}
        />
        <path
          d="M350.96 605.82C346.382 605.822 341.988 604.026 338.721 600.82C335.406 597.572 333.517 593.14 333.468 588.499C333.419 583.858 335.214 579.388 338.46 576.07L502.8 408.17C504.408 406.527 506.323 405.217 508.437 404.314C510.55 403.411 512.821 402.933 515.12 402.908C517.418 402.883 519.699 403.312 521.832 404.168C523.964 405.025 525.908 406.292 527.55 407.9C530.865 411.149 532.754 415.58 532.803 420.221C532.851 424.862 531.056 429.332 527.811 432.65L363.471 600.55C361.845 602.222 359.899 603.549 357.75 604.455C355.601 605.36 353.292 605.825 350.96 605.82Z"
          fill={color}
        />
      </svg>
    </div>
  );
}
